import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyLocation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.63333 14.6V13.2667C5.24444 13.1111 4.05278 12.5361 3.05833 11.5417C2.06389 10.5472 1.48889 9.35555 1.33333 7.96667H0V6.63333H1.33333C1.48889 5.24444 2.06389 4.05278 3.05833 3.05833C4.05278 2.06389 5.24444 1.48889 6.63333 1.33333V0H7.96667V1.33333C9.35555 1.48889 10.5472 2.06389 11.5417 3.05833C12.5361 4.05278 13.1111 5.24444 13.2667 6.63333H14.6V7.96667H13.2667C13.1111 9.35555 12.5361 10.5472 11.5417 11.5417C10.5472 12.5361 9.35555 13.1111 7.96667 13.2667V14.6H6.63333ZM7.3 11.9667C8.58889 11.9667 9.68889 11.5111 10.6 10.6C11.5111 9.68889 11.9667 8.58889 11.9667 7.3C11.9667 6.01111 11.5111 4.91111 10.6 4C9.68889 3.08889 8.58889 2.63333 7.3 2.63333C6.01111 2.63333 4.91111 3.08889 4 4C3.08889 4.91111 2.63333 6.01111 2.63333 7.3C2.63333 8.58889 3.08889 9.68889 4 10.6C4.91111 11.5111 6.01111 11.9667 7.3 11.9667ZM7.3 9.96667C6.56667 9.96667 5.93889 9.70555 5.41667 9.18333C4.89444 8.66111 4.63333 8.03333 4.63333 7.3C4.63333 6.56667 4.89444 5.93889 5.41667 5.41667C5.93889 4.89444 6.56667 4.63333 7.3 4.63333C8.03333 4.63333 8.66111 4.89444 9.18333 5.41667C9.70555 5.93889 9.96667 6.56667 9.96667 7.3C9.96667 8.03333 9.70555 8.66111 9.18333 9.18333C8.66111 9.70555 8.03333 9.96667 7.3 9.96667Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgMyLocation);
export default ForwardRef;
